<template>
	<div
		class="start-container"
		ref="startRef"
	>
		<div class="title">
			<div>Best of the Best</div>
			<div><center>F&I Manager's Cash Bash 2022</center></div>
		</div>
		<div class="middle">
			<img src="@static/img/raffle/logoRafle.png" />
		</div>
		<div class="button">
			<div class="footer">
				<div>Waiting to Start the Event</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'LiveStartGame',
		props: ['startGame'],
		data() {
			return {
				createRaffleInfo: null,
				newGame: null,
			};
		},
		computed: {},

		mounted() {
			this.$watch(
				() => this.startGame,
				function (newValue) {
					if (newValue) {
						this.$refs.startRef.classList.add('hide');
						this.$refs.startRef.style.display = 'none';
					} else {
						this.$refs.startRef.classList.remove('hide');
						this.$refs.startRef.style.display = 'flex';
					}
				},
				{ deep: true },
			);
		},
		methods: {},
	};
</script>
